// takes the user input and the provided tld
// if the user input doesn't have its own tld, we append the provided one
export const createFqdn = (domainName = '', tldPrefx = '') => {
  const hasSecondArgument = tldPrefx.length > 0;
  const shouldConcatenate = domainName.indexOf('.') === -1 && hasSecondArgument;
  if (shouldConcatenate) {
    return `${domainName}${tldPrefx}`;
  }
  return domainName;
};
// tld could either be com, .com, or null
// if the . is missing we want to prefix it
// if it's null we still want a string to be returned
export const prefxTld = (tld?: string) => {
  const trimmed = tld || ''.trim();
  if (trimmed.length === 0) {
    return '';
  }
  if (trimmed.startsWith('.')) {
    return trimmed;
  }
  return `.${trimmed}`;
};

export default null;
